<div>
   <app-helper [mobile]="true"></app-helper>
</div>
